// extracted by mini-css-extract-plugin
module.exports = {"svgWrapper":"BookPage_svgWrapper__3Dv-f","svgContent":"BookPage_svgContent__2ZPTH","disableSelection":"BookPage_disableSelection__2z486"};